import { editClient } from 'utils/stateToState';
import { EDIT_CLIENT } from 'constants/actionTypes';

export default function client(state = [], action) {
  switch (action.type) {
    case EDIT_CLIENT: {
      const { cl } = action;
      return editClient(state, cl);
    }
    default:
      return state;
  }
}
